import {
  type LucideIcon,
  House as Home20Filled,
  MessagesSquare as ChatMultiple20Filled,
  Users as People20Filled,
  Mail as Mail20Filled,
  ClipboardCheck as ClipboardTask20Filled,
  ChartBar as DataBarHorizontal20Filled,
  Settings as Settings20Filled,
  Phone as Call20Filled,
  Bot as Bot20Filled,
  Headset as Headset20Filled,
  MessageSquare as PersonFeedback20Filled,
  Calendar as Calendar20Filled,
  Bell as Alert20Filled,
  Send as Send20Filled,
  Image as Image20Filled,
  FileText as DocumentPageBreak20Filled,
  FilePlus as FormNew20Filled,
  FlaskConical as Beaker20Filled,
  Gift as Gift20Filled,
  ClipboardList as ClipboardDataBar20Filled,
  Notebook as Notebook20Filled,
  Globe as Globe20Filled,
  Smartphone as Phone20Filled,
  Plug as PlugConnected20Filled,
  FileText as DocumentBulletList20Filled,
  MapPin as Location20Filled,
  Building2 as Building20Filled,
  Building2 as Organization20Filled,
  UserRound as PersonAccounts20Filled,
  History as History20Filled,
  Key as Key20Filled,
  Video as Video20Filled,
  LayoutGrid as LayoutCellFour20Filled,
  Star as Star20Filled,
  CircleQuestionMark as QuestionCircle20Filled,
  UserRound as PersonInfo20Filled,
  Megaphone as Megaphone20Filled,
  Crosshair as TargetArrow20Filled,
  Code as Code20Filled,
  SlidersHorizontal as Options20Filled,
  ShieldCheck as ShieldTask20Filled,
} from "lucide-react";

import type { NavSection } from "@skypointcloud/skypoint-ui";

const HomeIcon = Home20Filled;
const ConversationsIcon = ChatMultiple20Filled;
const AudienceIcon = People20Filled;
const CampaignsIcon = Mail20Filled;
const DecisionSupportIcon = ClipboardTask20Filled;
const InsightsIcon = DataBarHorizontal20Filled;
const SettingsIcon = Settings20Filled;
const CallLogsIcon = Call20Filled;
const SupportIcon = Headset20Filled;
const LeadsIcon = PersonFeedback20Filled;
const TourIcon = Calendar20Filled;
const SmsAlertIcon = Alert20Filled;
const DripIcon = Send20Filled;
const ContentHubIcon = Image20Filled;
const LandingPagesIcon = DocumentPageBreak20Filled;
const FormsIcon = FormNew20Filled;
const ABTestIcon = Beaker20Filled;
const LeadMagnetsIcon = Gift20Filled;
const AssessmentsIcon = ClipboardDataBar20Filled;
const SurveysIcon = Notebook20Filled;
const TemplatesIcon = DocumentBulletList20Filled;
const SalesAgentIcon = Bot20Filled;
const UtmIcon = Globe20Filled;
const PhoneIcon = Phone20Filled;
const CallMgmtIcon = Call20Filled;
const CrmIcon = PlugConnected20Filled;
const LocationsIcon = Location20Filled;
const OperatorsIcon = Building20Filled;
const OwnersIcon = Organization20Filled;
const UsersIcon = PersonAccounts20Filled;
const LogsIcon = History20Filled;
const SessionIcon = Key20Filled;
const VideosIcon = Video20Filled;
const FloorPlansIcon = LayoutCellFour20Filled;
const TestimonialsIcon = Star20Filled;
const FaqIcon = QuestionCircle20Filled;
const StaffIcon = PersonInfo20Filled;
const BannersIcon = Megaphone20Filled;

const WidgetPlacementsIcon = TargetArrow20Filled;
const EmbedScriptIcon = Code20Filled;
const InquiryTypesIcon = Options20Filled;
const RolesIcon = ShieldTask20Filled;

export const NAV_IDS = {
  DASHBOARD: "dashboard",
  CONVERSATIONS: "conversations",
  INBOX: "inbox",
  CALL_LOGS: "call-logs",
  TRAINING: "training",
  AUDIENCE: "audience",
  LEADS: "leads",
  TOUR_AVAILABILITY: "tour-availability",
  SCHEDULED_TOURS: "scheduled-tours",
  SMS_ALERT_SETTINGS: "sms-alert-settings",
  CAMPAIGNS_HUB: "campaigns-hub",
  CAMPAIGNS: "campaigns",
  DRIP_CAMPAIGNS: "drip-campaigns",
  AUTO_TRIGGERS: "auto-triggers",
  LANDING_PAGES: "landing-pages",
  FORMS: "forms",
  AB_TESTS: "ab-tests",
  LEAD_MAGNETS: "lead-magnets",
  CONTENT_HUB: "content-hub",
  VIDEOS: "videos",
  FLOOR_PLANS: "floor-plans",
  TESTIMONIALS: "testimonials",
  FAQ: "faq",
  STAFF_PROFILES: "staff-profiles",
  ALERT_BANNERS: "alert-banners",
  DECISION_SUPPORT: "decision-support",
  ASSESSMENTS: "assessments",
  SURVEYS: "surveys",
  SURVEY_TEMPLATES: "survey-templates",
  SALES_AGENT: "sales-agent",
  ASA_LIST: "asa-list",
  MODAL_CONFIGS: "modal-configs",
  WIDGET_PLACEMENTS: "widget-placements",
  EMBED_SCRIPT: "embed-script",
  INQUIRY_TYPES: "inquiry-types",
  INSIGHTS: "insights",
  ANALYTICS: "analytics",
  CAMPAIGN_ATTRIBUTION: "campaign-attribution",
  UTM_ANALYTICS: "utm-analytics",
  CALL_ANALYTICS: "call-analytics",
  ADVISOR_REPORTS: "advisor-reports",
  MODAL_ANALYTICS: "modal-analytics",
  SETTINGS: "settings",
  GENERAL: "general",
  USERS: "users",
  USER_SETUP: "user_setup",
  ROLES: "roles",
  LOCATIONS: "locations",
  OPERATORS: "operators",
  OWNERS: "owners",
  CHANNELS: "channels",
  CALL_MANAGEMENT: "call-management",
  LOGS: "logs",
  PLATFORM: "platform",
  INSTANCES: "instances",
  TENANTS: "tenants",
  INTEGRATIONS: "integrations",
  CRM: "crm",
  NOTIFICATION_PREFERENCES: "notification-preferences",
  CONFIGURATIONS: "configurations",
  // H3 Inc-2 — the Advisor Settings child for the close-reason catalog.
  CLOSE_REASONS: "close-reasons",
  // PACE (`pipeline_funnel`) — the Advisor Settings child for stage renames.
  STAGES: "stages",
  // R6 — the Advisor Setup hub. Absorbs the Settings sub-items as TILES.
  SETTINGS_SETUP: "settings-setup",
  // Sky CRM (/crm/*) — distinct from NAV_IDS.CRM ("crm" = legacy CRM
  // Integrations). Senior Living section ids; pack-gated.
  CRM_OVERVIEW: "crm-overview",
  CRM_DAY_PLANNER: "crm-day-planner",
  CRM_PERSONS: "crm-persons",
  CRM_RESIDENTS: "crm-residents",
  // Parent (category) of the two referrer surfaces below. Follows the
  // CAMPAIGNS_HUB precedent: it owns no page of its own, is never the
  // selected item, and exists so the two children can nest under one label.
  CRM_REFERRERS_HUB: "crm-referrers-hub",
  CRM_REFERRERS: "crm-referrers",
  CRM_ORGANIZATIONS: "crm-organizations",
  CRM_ADMISSIONS: "crm-admissions",
  // Parent (category) of the Occupancy surfaces. Same precedent as
  // CRM_REFERRERS_HUB: owns no page, is never the selected item, exists so the
  // Yardi Resolution Center can nest under Occupancy where the reference puts it.
  CRM_OCCUPANCY_HUB: "crm-occupancy-hub",
  CRM_OCCUPANCY: "crm-occupancy",
  CRM_YARDI_RESOLUTION: "crm-yardi-resolution",
  CRM_REPORTS: "crm-reports",
  CRM_EVENTS: "crm-events",
  CRM_HEALTH: "crm-health",
  CRM_SKYAGENT: "crm-skyagent",
  CRM_SKYBRAIN: "crm-skybrain",
  CRM_AGENT_SKILLS: "crm-agent-skills",
  CRM_AGENT_DRAFTS: "crm-agent-drafts",
  CRM_MCP_CONNECTORS: "crm-mcp-connectors",
  CRM_MESSENGER: "crm-messenger",
  CRM_SETUP: "crm-setup",
  CRM_LEAD_SOURCES: "crm-lead-sources",
  CRM_MESSAGE_TEMPLATES: "crm-message-templates",
  CRM_COMMUNICATION_TEMPLATES: "crm-communication-templates",
  CRM_GOALS: "crm-goals",
  CRM_CLINICAL_SYNC: "crm-clinical-sync",
  HELP_SUPPORT: "help-support",
} as const;

export type NavId = (typeof NAV_IDS)[keyof typeof NAV_IDS];

interface PermissionFlags {
  isFullAccess: boolean;
  isTenantAdmin: boolean;
  isPlatformAdmin: boolean;
  isInstanceAdmin: boolean;
  rbacNavigation?: Record<string, boolean>; // RBAC navigation permissions
  // Platform `manageSettings` permission (admin-bypassed at the call site:
  // callers pass `permissions.manageSettings || isAdmin`). Optional so callers
  // that do not resolve it — e.g. RouteGuard, which intentionally enforces route
  // access off the HARDCODED `buildNavSections` and never on this flag — leave it
  // undefined. Only `buildNavSectionsFromConfig` reads it (via PROTECTED_NAV_GATES).
  canManageSettings?: boolean;
  /**
   * H3 Inc-2 — does any installed pack declare the `close_reasons` capability?
   * (`usePacks().hasFeature`, the client twin of the server's
   * `requirePackFeature`.) Optional for exactly the same reason
   * `canManageSettings` is: RouteGuard enforces route ACCESS off the HARDCODED
   * `buildNavSections` and never resolves pack state, so it leaves this
   * undefined. Only `buildNavSectionsFromConfig` reads it, via
   * PROTECTED_NAV_GATES — undefined therefore hides the tab (the tab appears a
   * beat late while packs load, never as a dead door) without ever revoking the
   * route.
   */
  hasCloseReasonsFeature?: boolean;
  /**
   * PACE — does any installed pack declare `pipeline_funnel`? Optional and
   * read only by `buildNavSectionsFromConfig`, for exactly the reasons
   * `hasCloseReasonsFeature` is (undefined hides the tab, never the route).
   */
  hasPipelineFunnelFeature?: boolean;
}

/**
 * The security floor for admin / settings nav surfaces, keyed by resolved NavId.
 *
 * ⚠️ APPLIED ONLY INSIDE `buildNavSectionsFromConfig` (the data-driven builder),
 * never in `buildNavSections`. The config-driven render can otherwise draw
 * admin/settings tabs the schema lists but the API refuses on click (a dead
 * door): the config builder only gates children on `child.permission` +
 * `adminOnly`, so a Settings surface carrying neither leaks through. This map is
 * the render floor that closes that leak — a tab is dropped when its NavId is a
 * key here and the gate returns false for the caller's flags.
 *
 * It is deliberately NOT wired into `buildNavSections`: RouteGuard derives route
 * ACCESS from that hardcoded builder, and `/crm-integrations` (NAV_IDS.INTEGRATIONS)
 * is a read-only-reachable page — gating it there would redirect legitimate
 * viewers away from a working page. So `INTEGRATIONS` lives here (hide the
 * config-driven menu tab for non-managers) while the route stays reachable.
 *
 * Non-protected (custom) schema items are untouched — no global floor — so a
 * tenant's bespoke routes are never hidden by this map.
 */
export const PROTECTED_NAV_GATES: Partial<Record<NavId, (flags: PermissionFlags) => boolean>> = {
  // Users / Roles: current behaviour — the `showUsers` nav permission OR the
  // admin hierarchy (isAdmin covers tenant/platform, isInstanceAdmin explicit).
  [NAV_IDS.USERS]: (flags) =>
    flags.rbacNavigation?.showUsers === true ||
    flags.isTenantAdmin ||
    flags.isPlatformAdmin ||
    flags.isInstanceAdmin,
  [NAV_IDS.ROLES]: (flags) =>
    flags.rbacNavigation?.showUsers === true ||
    flags.isTenantAdmin ||
    flags.isPlatformAdmin ||
    flags.isInstanceAdmin,
  // Channels / Session (PLATFORM) / Integrations / Configurations:
  // `canManageSettings || isAdmin`. The call site already folds isAdmin into
  // canManageSettings, but the gate ORs the admin hierarchy too so a caller that
  // passes raw admin flags without canManageSettings still admin-bypasses.
  [NAV_IDS.CHANNELS]: (flags) =>
    flags.canManageSettings === true ||
    flags.isTenantAdmin ||
    flags.isPlatformAdmin ||
    flags.isInstanceAdmin,
  [NAV_IDS.PLATFORM]: (flags) =>
    flags.canManageSettings === true ||
    flags.isTenantAdmin ||
    flags.isPlatformAdmin ||
    flags.isInstanceAdmin,
  [NAV_IDS.INTEGRATIONS]: (flags) =>
    flags.canManageSettings === true ||
    flags.isTenantAdmin ||
    flags.isPlatformAdmin ||
    flags.isInstanceAdmin,
  [NAV_IDS.CONFIGURATIONS]: (flags) =>
    flags.canManageSettings === true ||
    flags.isTenantAdmin ||
    flags.isPlatformAdmin ||
    flags.isInstanceAdmin,
  // R6 — the Advisor Setup hub. Its gate is the UNION of its tiles' gates, so
  // the door is shown to anyone entitled to at least one tile and to nobody
  // entitled to none. Every tile is `adminOnly` or `manageSettings`, so the
  // union is exactly the CONFIGURATIONS tier.
  //
  // ⚠️ Deliberately NOT OR-ed with `showUsers`. A non-admin holding only that
  // flag is entitled to ZERO tiles — the Users and Roles pages are admin-only
  // in their own handlers — so admitting them would open the hub onto its
  // "you don't have access to any settings" state. The Settings menu did show
  // them a Users door; that door 403s, which is why the hub does not reproduce
  // it (see the tile comments in SettingsSetupPage).
  [NAV_IDS.SETTINGS_SETUP]: (flags) =>
    flags.canManageSettings === true ||
    flags.isTenantAdmin ||
    flags.isPlatformAdmin ||
    flags.isInstanceAdmin,
  // Close Reasons: the CONFIGURATIONS tier (canManageSettings || admin) AND the
  // pack-feature check. Both halves matter and they answer different questions:
  // the permission is "may this person author the catalog?" (the API's
  // mutations are manageSettings), and the feature is "does this tenant have a
  // lead funnel at all?". Hide-at-render, enforce-at-server — the omit-don't-
  // disable doctrine; requirePackFeature 403s a tenant whose packs don't
  // declare it, so this gate is convenience, not security.
  [NAV_IDS.CLOSE_REASONS]: (flags) =>
    flags.hasCloseReasonsFeature === true &&
    (flags.canManageSettings === true ||
      flags.isTenantAdmin ||
      flags.isPlatformAdmin ||
      flags.isInstanceAdmin),
  // Stages (PACE): the Close Reasons gate's twin — the same admin clause, keyed
  // on `pipeline_funnel`. The rename PATCH is manageSettings; the whole
  // lifecycle router 404s for a tenant without the feature.
  [NAV_IDS.STAGES]: (flags) =>
    flags.hasPipelineFunnelFeature === true &&
    (flags.canManageSettings === true ||
      flags.isTenantAdmin ||
      flags.isPlatformAdmin ||
      flags.isInstanceAdmin),
  // Call Management / Activity Logs / Notifications: admin-only surfaces.
  [NAV_IDS.CALL_MANAGEMENT]: (flags) =>
    flags.isTenantAdmin || flags.isPlatformAdmin || flags.isInstanceAdmin,
  [NAV_IDS.LOGS]: (flags) => flags.isTenantAdmin || flags.isPlatformAdmin || flags.isInstanceAdmin,
  [NAV_IDS.NOTIFICATION_PREFERENCES]: (flags) =>
    flags.isTenantAdmin || flags.isPlatformAdmin || flags.isInstanceAdmin,
};

export function buildNavSections(permissions: PermissionFlags): NavSection[] {
  const { isTenantAdmin, isPlatformAdmin, isInstanceAdmin, rbacNavigation } = permissions;
  const isAdmin = isTenantAdmin || isPlatformAdmin || isInstanceAdmin;

  // Helper to check if nav item should be shown
  const shouldShow = (navKey: string): boolean => {
    // Admins always see everything (they have full access regardless of RBAC)
    if (isAdmin) return true;

    // If user has RBAC role assigned, check their navigation permissions
    if (rbacNavigation) {
      return rbacNavigation[navKey] === true;
    }

    // No RBAC role = NO access
    return false;
  };

  // No admin access AND no RBAC role = minimal nav only
  if (!isAdmin && !rbacNavigation) {
    return [
      {
        header: "Support",
        items: [
          {
            id: NAV_IDS.HELP_SUPPORT,
            label: "Help + Support",
            icon: SupportIcon,
          },
        ],
      },
    ];
  }

  // Admin or has RBAC role - build filtered nav
  const sections: NavSection[] = [];

  // Home section
  if (shouldShow("showDashboard")) {
    sections.push({
      header: "Home",
      items: [
        {
          id: NAV_IDS.DASHBOARD,
          label: "Dashboard",
          icon: HomeIcon,
        },
      ],
    });
  }

  // Conversations section
  const conversationItems = [];
  if (shouldShow("showInbox")) {
    conversationItems.push({
      id: NAV_IDS.INBOX,
      label: "Inbox",
      icon: ConversationsIcon,
    });
  }
  if (shouldShow("showCallLogs")) {
    conversationItems.push({
      id: NAV_IDS.CALL_LOGS,
      label: "Calls",
      icon: CallLogsIcon,
    });
  }
  if (conversationItems.length > 0) {
    sections.push({
      header: "Conversations",
      items: conversationItems,
    });
  }

  // Audience section
  const audienceItems = [];
  if (shouldShow("showLeads")) {
    audienceItems.push({
      id: NAV_IDS.LEADS,
      label: "Leads",
      icon: LeadsIcon,
    });
  }
  if (shouldShow("showTours")) {
    audienceItems.push({
      id: NAV_IDS.SCHEDULED_TOURS,
      label: "Scheduled Tours",
      icon: TourIcon,
    });
    if (isAdmin) {
      audienceItems.push({
        id: NAV_IDS.SMS_ALERT_SETTINGS,
        label: "Alerts",
        icon: SmsAlertIcon,
      });
    }
  }
  if (audienceItems.length > 0) {
    sections.push({
      header: "Audience",
      items: audienceItems,
    });
  }

  // Campaigns section
  const campaignItems = [];
  if (shouldShow("showCampaigns")) {
    campaignItems.push({
      id: NAV_IDS.CAMPAIGNS_HUB,
      label: "Campaigns",
      icon: CampaignsIcon,
      children: [
        { id: NAV_IDS.CAMPAIGNS, label: "Ad Campaigns", icon: CampaignsIcon },
        { id: NAV_IDS.DRIP_CAMPAIGNS, label: "Drip Campaigns", icon: CampaignsIcon },
      ],
    });
  }
  if (shouldShow("showContentHub")) {
    campaignItems.push({
      id: NAV_IDS.CONTENT_HUB,
      label: "Content Hub",
      icon: ContentHubIcon,
      children: [
        { id: NAV_IDS.STAFF_PROFILES, label: "Staff Profiles", icon: StaffIcon },
        { id: NAV_IDS.ALERT_BANNERS, label: "Alert Banners", icon: BannersIcon },
      ],
    });
  }
  if (campaignItems.length > 0) {
    sections.push({
      header: "Campaigns",
      items: campaignItems,
    });
  }

  // Decision Support section
  const decisionSupportItems = [];
  if (shouldShow("showAssessments")) {
    decisionSupportItems.push({
      id: NAV_IDS.ASSESSMENTS,
      label: "Assessments",
      icon: AssessmentsIcon,
    });
  }
  if (shouldShow("showSurveys")) {
    decisionSupportItems.push({
      id: NAV_IDS.SURVEYS,
      label: "Surveys",
      icon: SurveysIcon,
    });
    decisionSupportItems.push({
      id: NAV_IDS.SURVEY_TEMPLATES,
      label: "Templates",
      icon: TemplatesIcon,
    });
  }
  if (shouldShow("showASA")) {
    decisionSupportItems.push({
      id: NAV_IDS.SALES_AGENT,
      label: "Sales Agent",
      icon: SalesAgentIcon,
      children: [
        { id: NAV_IDS.ASA_LIST, label: "Agent List", icon: SalesAgentIcon },
        ...(isAdmin
          ? [
              { id: NAV_IDS.EMBED_SCRIPT, label: "Embed Script", icon: EmbedScriptIcon },
              { id: NAV_IDS.TOUR_AVAILABILITY, label: "Tour Availability", icon: TourIcon },
            ]
          : []),
      ],
    });
  }
  if (decisionSupportItems.length > 0) {
    sections.push({
      header: "Decision Support",
      items: decisionSupportItems,
    });
  }

  // Insights section
  if (shouldShow("showAnalytics")) {
    sections.push({
      header: "Insights",
      items: [
        {
          id: NAV_IDS.ANALYTICS,
          label: "Overview",
          icon: InsightsIcon,
        },
        {
          id: NAV_IDS.CAMPAIGN_ATTRIBUTION,
          label: "Campaign Attribution",
          icon: InsightsIcon,
        },
        {
          id: NAV_IDS.UTM_ANALYTICS,
          label: "UTM Analytics",
          icon: UtmIcon,
        },
        {
          id: NAV_IDS.CALL_ANALYTICS,
          label: "Call Analytics",
          icon: CallLogsIcon,
        },
        // The Advisor surface of the Reports hub. Sits in Insights beside the
        // other analytics entries rather than as a new top-level section: an
        // operator looking for numbers already looks here.
        {
          id: NAV_IDS.ADVISOR_REPORTS,
          label: "Reports",
          icon: InsightsIcon,
        },
      ],
    });
  }

  // Settings section - always show Help + Support, conditionally show Settings
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const settingsItems: any[] = [
    {
      id: NAV_IDS.HELP_SUPPORT,
      label: "Help + Support",
      icon: SupportIcon,
    },
  ];

  if (shouldShow("showSettings")) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const settingsChildren: any[] = [];

    // ── R6: the Setup hub door, FIRST (the CRM Setup precedent) ─────────────
    //
    // ⚠️ ADDED, and nothing below it removed. RouteGuard derives route ACCESS
    // from THIS builder (RouteGuard.tsx:50-60), so deleting a child here would
    // not hide a menu item — it would make /users, /roles, /channels and the
    // rest UNREACHABLE for every persona, Advisor and CRM alike. That is the
    // PR #1523 breakage.
    //
    // The REPLACE half of R6 therefore happens where it safely can: in the
    // CONFIG-driven render, whose children come from each tenant's
    // platform_config row. `scripts/advisor-setup-nav.ts` performs that
    // rewrite as a reversible deployment step, run only AFTER the hub and every
    // tile destination are verified (R6-C3). Until then a hardcoded-fallback
    // tenant sees Setup ALONGSIDE the old children — a duplicated menu, which
    // is the deliberately preferred failure mode over a lost route.
    settingsChildren.push({ id: NAV_IDS.SETTINGS_SETUP, label: "Setup", icon: SettingsIcon });

    if (shouldShow("showUsers") || isAdmin || isInstanceAdmin) {
      settingsChildren.push({ id: NAV_IDS.USERS, label: "Users", icon: UsersIcon });
      settingsChildren.push({ id: NAV_IDS.ROLES, label: "Role Management", icon: RolesIcon });
    }
    settingsChildren.push({ id: NAV_IDS.CHANNELS, label: "Channels", icon: SettingsIcon });
    if (isAdmin) {
      settingsChildren.push({
        id: NAV_IDS.CALL_MANAGEMENT,
        label: "Call Management",
        icon: CallMgmtIcon,
      });
    }
    if (isAdmin) {
      settingsChildren.push({ id: NAV_IDS.LOGS, label: "Activity Logs", icon: LogsIcon });
    }
    if (isAdmin) {
      settingsChildren.push({
        id: NAV_IDS.NOTIFICATION_PREFERENCES,
        label: "Notifications",
        icon: SmsAlertIcon,
      });
    }
    settingsChildren.push({ id: NAV_IDS.PLATFORM, label: "Session", icon: SessionIcon });
    settingsChildren.push({ id: NAV_IDS.INTEGRATIONS, label: "Integrations", icon: CrmIcon });
    settingsChildren.push({
      id: NAV_IDS.CONFIGURATIONS,
      label: "Configurations",
      icon: SettingsIcon,
    });
    // H3 Inc-2 — listed UNCONDITIONALLY here, on purpose. RouteGuard derives
    // route ACCESS from this builder, so gating the entry here would not hide a
    // menu item, it would make /settings/close-reasons unreachable for every
    // persona (the #1523 breakage). The permission + pack-feature gate belongs
    // in PROTECTED_NAV_GATES, which only buildNavSectionsFromConfig applies.
    settingsChildren.push({
      id: NAV_IDS.CLOSE_REASONS,
      label: "Close Reasons",
      icon: SettingsIcon,
    });
    // PACE — unconditional for the same RouteGuard reason as Close Reasons.
    settingsChildren.push({
      id: NAV_IDS.STAGES,
      label: "Stages",
      icon: SettingsIcon,
    });

    settingsItems.push({
      id: NAV_IDS.SETTINGS,
      label: "Settings",
      icon: SettingsIcon,
      children: settingsChildren,
    });
  }

  sections.push({
    header: "Settings",
    items: settingsItems,
  });

  return sections;
}

// ─── Config-driven nav builder ──────────────────────────────────────────────

/** Icon name string → bundled icon component mapping */
const ICON_MAP: Record<string, LucideIcon> = {
  Home20: HomeIcon,
  ChatMultiple20: ConversationsIcon,
  Call20: CallLogsIcon,
  People20: LeadsIcon,
  Calendar20: TourIcon,
  Alert20: SmsAlertIcon,
  Mail20: CampaignsIcon,
  Image20: ContentHubIcon,
  Video20: VideosIcon,
  LayoutCellFour20: FloorPlansIcon,
  Star20: TestimonialsIcon,
  QuestionCircle20: FaqIcon,
  PersonInfo20: StaffIcon,
  Megaphone20: BannersIcon,
  ClipboardDataBar20: AssessmentsIcon,
  Notebook20: SurveysIcon,
  DocumentBulletList20: TemplatesIcon,
  Bot20: SalesAgentIcon,
  DataBarHorizontal20: InsightsIcon,
  Globe20: UtmIcon,
  Headset20: SupportIcon,
  Settings20: SettingsIcon,
  PersonAccounts20: UsersIcon,
  ShieldTask20: RolesIcon,
  Phone20: PhoneIcon,
  History20: LogsIcon,
  Key20: SessionIcon,
  PlugConnected20: CrmIcon,
  Code20: EmbedScriptIcon,
  Options20: InquiryTypesIcon,
  TargetArrow20: WidgetPlacementsIcon,
  Send20: DripIcon,
  DocumentPageBreak20: LandingPagesIcon,
  FormNew20: FormsIcon,
  Beaker20: ABTestIcon,
  Gift20: LeadMagnetsIcon,
  PersonFeedback20: LeadsIcon,
  ClipboardTask20: DecisionSupportIcon,
  Location20: LocationsIcon,
  Building20: OperatorsIcon,
  Organization20: OwnersIcon,
};

function resolveIcon(iconName: string): LucideIcon {
  return ICON_MAP[iconName] || SettingsIcon;
}

export interface SidebarConfigItem {
  name: string;
  displayName: string;
  icon: string;
  section: string;
  priority: number;
  isVisible: boolean;
  permission?: string;
  adminOnly?: boolean;
  hasTab?: boolean;
  tabUrl?: string;
  dataUrl?: string | null;
  children?: Array<{
    name: string;
    displayName: string;
    icon: string;
    priority: number;
    isVisible: boolean;
    permission?: string;
  }>;
}

/**
 * Map legacy seed names (stored in platform_config DB) to the NAV_IDS
 * used by the frontend route mapping. New seeds use the correct names,
 * but existing tenants may still have the old names in their DB.
 */
const SEED_NAME_TO_NAV_ID: Record<string, string> = {
  "sms-alerts": NAV_IDS.SMS_ALERT_SETTINGS,
  "ad-campaigns": NAV_IDS.CAMPAIGNS,
  "templates": NAV_IDS.SURVEY_TEMPLATES,
  "activity-logs": NAV_IDS.LOGS,
  "notifications": NAV_IDS.NOTIFICATION_PREFERENCES,
  "session": NAV_IDS.PLATFORM,
};

function resolveNavId(seedName: string): NavId {
  return (SEED_NAME_TO_NAV_ID[seedName] || seedName) as NavId;
}

/**
 * Build nav sections from platform_config sidebar schema.
 * Falls back to hardcoded buildNavSections if no config items provided.
 */
export function buildNavSectionsFromConfig(
  configItems: SidebarConfigItem[],
  permissions: PermissionFlags,
): NavSection[] {
  const { isTenantAdmin, isPlatformAdmin, isInstanceAdmin, rbacNavigation } = permissions;
  const isAdmin = isTenantAdmin || isPlatformAdmin || isInstanceAdmin;

  const shouldShow = (navKey?: string): boolean => {
    if (isAdmin) return true;
    if (!navKey) return true;
    if (rbacNavigation) return rbacNavigation[navKey] === true;
    return false;
  };

  // Security floor: a schema-listed tab whose resolved NavId is a
  // PROTECTED_NAV_GATES key is dropped when its gate fails for these flags,
  // regardless of what the schema says (the schema can list admin/settings
  // surfaces with no permission/adminOnly, which would otherwise leak — a dead
  // door that 403s/redirects on click). Non-protected (custom) ids pass through.
  const passesProtectedGate = (navId: NavId): boolean => {
    const gate = PROTECTED_NAV_GATES[navId];
    return gate ? gate(permissions) : true;
  };

  if (!isAdmin && !rbacNavigation) {
    return [
      {
        header: "Support",
        items: [{ id: "help-support" as NavId, label: "Help + Support", icon: SupportIcon }],
      },
    ];
  }

  // Group items by section, respecting priority order
  const sorted = [...configItems]
    .filter((item) => item.isVisible)
    .filter((item) => shouldShow(item.permission))
    .filter((item) => !item.adminOnly || isAdmin)
    .sort((a, b) => a.priority - b.priority);

  const sectionMap = new Map<string, Array<{ item: SidebarConfigItem }>>();
  for (const item of sorted) {
    if (!sectionMap.has(item.section)) {
      sectionMap.set(item.section, []);
    }
    sectionMap.get(item.section)!.push({ item });
  }

  const sections: NavSection[] = [];
  for (const [header, items] of sectionMap) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const navItems: any[] = [];
    for (const { item } of items) {
      const navId = resolveNavId(item.name);
      // Drop a protected top-level item whose gate fails (security floor).
      if (!passesProtectedGate(navId)) continue;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const navItem: any = {
        id: navId,
        label: item.displayName,
        icon: resolveIcon(item.icon),
      };

      if (item.children?.length) {
        navItem.children = item.children
          .filter((c) => c.isVisible)
          .filter((c) => !c.permission || shouldShow(c.permission))
          // Same security floor for children: drop a protected child whose gate
          // fails, by its resolved NavId.
          .filter((c) => passesProtectedGate(resolveNavId(c.name)))
          .sort((a, b) => a.priority - b.priority)
          .map((child) => ({
            id: resolveNavId(child.name),
            label: child.displayName,
            icon: resolveIcon(child.icon),
          }));

        // An item that HAD children in the schema but lost them ALL to the
        // protected-gate / isVisible / permission filtering must NOT be pushed
        // as a bare parent: it would navigate to a settings landing and become a
        // NEW dead door (e.g. a non-manager whose Settings children are every one
        // gated out). Leaf items that never declared a `children` array are
        // untouched by this guard and still render.
        if (navItem.children.length === 0) continue;
      }

      navItems.push(navItem);
    }

    if (navItems.length > 0) {
      sections.push({ header, items: navItems });
    }
  }

  /*
   * ⚠️ REPORTS IS OWNED BY CODE, NOT BY THE STORED SCHEMA.
   *
   * This builder is EXCLUSIVE: a tenant with a `(category='sidebar',
   * data='tabs')` row never consults the hardcoded list, and those rows predate
   * every surface added since — so a new entry is unreachable from the menu
   * until somebody patches each tenant's JSON. `scripts/advisor-setup-nav.ts`
   * spells that out, and browser UAT is what caught this one: the Reports entry
   * was added to the hardcoded builder and simply did not render.
   *
   * Rather than a per-tenant data step that every future tenant must also
   * receive, the entry is appended here — the same call the H3 Languages wizard
   * step made, and for the same reason: a surface gated on a stored list is
   * invisible on every tenant whose list was written before it existed.
   *
   * Appended to Insights when that section is present, and NOT created when it
   * is absent — a tenant with Insights switched off has said something, and
   * reintroducing the section under it would override that.
   */
  const insights = sections.find((s) => s.header === "Insights");
  if (insights && !insights.items.some((i) => i.id === NAV_IDS.ADVISOR_REPORTS)) {
    insights.items.push({
      id: NAV_IDS.ADVISOR_REPORTS,
      label: "Reports",
      icon: InsightsIcon,
    });
  }

  return sections;
}
